import type { SVGProps } from 'react';
const SvgPlaylistAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#playlist_add_svg__a)">
      <path
        fill="currentColor"
        d="M14 10H2v2h12v-2Zm0-4H2v2h12V6Zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4ZM2 16h8v-2H2v2Z"
      />
    </g>
    <defs>
      <clipPath id="playlist_add_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlaylistAdd;
